import {CommandClause} from "../command";
import {PsdkConst} from "../types";

export interface Arg<T> {
  header(): T;

  newline(): boolean;

  prepend(arg: Arg<T>): Arg<T>;

  append(arg: Arg<T>): Arg<T>;

  clause(): CommandClause;

  clauses(): Array<CommandClause>;

  clear();
}

export abstract class BasicArg<T> implements Arg<T> {
  abstract append(arg: Arg<T>): BasicArg<T>;

  abstract clause(): CommandClause;

  abstract clauses(): Array<CommandClause>;

  abstract clear();

  abstract header(): T;

  newline(): boolean {
    return PsdkConst.DEF_ENABLED_NEWLINE;
  }

  abstract prepend(arg: Arg<T>): BasicArg<T>;
}
